<template>
  <div class="mask" v-if="isShow" @click="closeAddress()"></div>
  <div class="dialog" v-if="isShow">
    <div class="dialog-title">收货人信息</div>
    <div class="dialog_con">
      <div class="dialog-control">
        <span>所在地区</span>
        <ChooseAddress
          v-if="isShow"
          :parentData="parentData"
          @getAddress="getAddress"
        />
      </div>
      <div class="dialog-control">
        <span>详细地址</span>
        <input type="text" v-model="detailAddress" />
      </div>
      <div class="dialog-control">
        <span>收货人</span>
        <input type="text" v-model="consignee" />
      </div>

      <div class="dialog-control">
        <span>手机号码</span>
        <input
          type="text"
          v-model="telePhone"
          oninput="if(value.length>5)value=value.slice(0,11)"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          maxlength="11"
        />
      </div>
      <div class="dialog-control btns">
        <div @click="saveAddress()" class="btn">保存</div>
        <div @click="closeAddress()" class="btn close">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseAddress from './ChooseAddress'
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { posts } from '../utils/posts'
export default {
  emits: ['canClose', 'closeAddress', 'saveAddress'],
  name: 'ConsigneeInformation',
  props: {
    isShow: Boolean,
    address: {
      type: Object
    }
  },
  setup (props, context) {
    const store = useStore()
    const userInfo = store.state.userInfo
    const pid = ref(props.address ? props.address.id : 0)
    const province = ref(props.address ? props.address.province : '')
    const city = ref(props.address ? props.address.city : '')
    const district = ref(props.address ? props.address.district : '')
    const detailAddress = ref(props.address ? props.address.detailAddress : '')
    const consignee = ref(props.address ? props.address.consignee : '')
    const telePhone = ref(props.address ? props.address.telePhone : '')
    const parentData = ref(
      province.value
        ? [{ name: province }, { name: city }, { name: district }]
        : []
    )

    const getAddress = (params) => {
      province.value = params[0].name
      city.value = params[1].name
      district.value = params[2].name
    }
    // 保存收货地址
    const saveAddress = () => {
      const addressObj = {
        id: pid.value,
        province: province.value,
        city: city.value,
        district: district.value,
        detailAddress: detailAddress.value,
        consignee: consignee.value,
        telePhone: telePhone.value
      }
      posts(`address/update/${userInfo.uid}`, addressObj).then((res) => {
        document.body.style.overflow = ''
        store.commit('showMsg', {
          isShow: true,
          msg: res.msg,
          second: 2
        })
        context.emit('canClose')
      })
    }
    // 关闭弹出层
    const closeAddress = () => {
      document.body.style.overflow = ''
      context.emit('canClose')
    }

    onMounted(() => {
      // document.body.style.overflow = "hidden";
    })
    return {
      pid,
      getAddress,
      saveAddress,
      closeAddress,
      province,
      city,
      district,
      detailAddress,
      consignee,
      telePhone,
      parentData
    }
  },
  components: {
    ChooseAddress
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100;
}
.dialog {
  position: absolute;
  width: 530px;
  height: 380px;
  background: #fff;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 200px auto;
  border-radius: 6px;
  overflow: hidden;
  font-size: 14px;
  z-index: 101;

}
.dialog_con{
  width: 480px;
  margin: 0 auto;
}
.dialog-title {
  background-color: #f3f3f3;
  font-size: 18px;
  color: #666;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  margin: 0 0 16px 0;
}
.dialog-control {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  width: 100%;
}

.dialog-control span {
  margin-right: 10px;
  width: 60px;
}
.dialog-control div {
  margin-right: 10px;
  height: 36px;
  width: 377px;
  border: 1px solid #ccc;
}
.dialog-control input {
  height: 36px;
  width: 360px;
  border: 1px solid #ccc;
  padding: 0 4px;
}
.btns {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 0 0;
}
.btns .btn {
  width: 80px;
  height: 40px;
  background-color: #fc4353;
  font-size: 16px;
  line-height: 40px;
  margin-right: 20px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  border: none;
}
.btns .close {
  background-color: #dbdbdb;
  margin-right: 0;
}
</style>
